import gql from "graphql-tag";

export default gql`
  mutation StartRTMP($eventId: ID, $componentName: String) {
    startRTMP(eventId: $eventId, componentName: $componentName) {
      id
    }
  }
`;
